import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import {
    Typography,
    Grid,
    useMediaQuery,
    IconButton,
    DialogActions,
    DialogContent,
    DialogTitle,
    Dialog
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonView } from '../../../components/Button';
import { InputLabel } from '../../../../home/Home-components';
import { Input } from '../../../components/Input';
import { addQuotesPriceTables } from 'services';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export const ConfigTableDialog = (props: any) => {
    const [noOfTables, setNoOfTables] = useState<any | null>(null);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleChange = (e: any) => {
        let tables: number = parseInt(e.target.value);
        setNoOfTables(tables);
    }

    const submitData = () => {
        if (noOfTables && props.quoteID) {
            let obj = {
                'noOfTables': noOfTables,
                'quoteID': props.quoteID
            }
            addQuotesPriceTables(obj).then((res: any) => {
                if (res.status === 200) {
                    props.getTableDetails(res.data);
                }
            });
        }
        props.onClose();
    }

    return (
        <div>
            <BootstrapDialog
                onClose={props.onClose}
                aria-labelledby={props.labelledby}
                open={props.open}
                fullScreen={fullScreen}
                fullWidth={true}
                sx={{ padding: 10 }}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose}>
                    Configure Table Type Dialog
                </BootstrapDialogTitle>
                <DialogContent dividers style={{ padding: 40 }}>                    
                    <Grid container spacing={3} style={{ paddingTop: 30 }}>
                        <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    # of Tables ?
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0, paddingLeft: 32 }}>
                            <Input
                                size='small'
                                sx={{ width: '100%' }}
                                type="number"
                                onBlur={handleChange}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonView variant="contained" name='Add Table' color="primary" type='submit' startIcon={<AddCircleOutlineOutlinedIcon />} onClick={submitData} />
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
